import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-main">
        {/* BRAND */}
        <div className="footer-brand">
          <h2>STAR GOLD</h2>

          <p className="footer-tagline">Luxury Jewellery & Accessories</p>

          <p className="footer-description">
            Discover elegant jewellery pieces crafted to make every special
            occasion memorable.
          </p>
        </div>

        {/* QUICK LINKS */}
        <div className="footer-column">
          <h3>Explore</h3>

          <Link to="/">Home</Link>
          <Link to="/collections">Collections</Link>
          <Link to="/wishlist">Wishlist</Link>
          <Link to="/track-order">Track Order</Link>
        </div>

        {/* CUSTOMER */}
        <div className="footer-column">
          <h3>Customer</h3>

          <Link to="/contact">Contact</Link>
          <Link to="/cart">Shopping Cart</Link>
          <Link to="/checkout">Checkout</Link>
        </div>

        {/* CONTACT */}
        <div className="footer-column footer-contact">
          <h3>Visit Us</h3>

          <p>Dharmavaram</p>
          <p>Andhra Pradesh, India</p>
          <p>WhatsApp Enquiries</p>
          <p>Store Opening Hours</p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2026 STAR GOLD. All rights reserved.</p>

        <p>Luxury Jewellery & Accessories</p>
      </div>
    </footer>
  );
};

export default Footer;
